import { CurrencyFormatter } from '@mixins/currency-formatter-mixin';
import Customer from '@models/customer';
import CustomerLocation from '@models/customer-location';
import Model from '@models/model';
import Proposal from '@models/proposal';

export const JOB_TYPE_PROGRESSIVE = 'Progressive';
export const JOB_TYPE_NORMAL = 'Normal';
export const JOB_TYPE_SERVICE = 'Service';
export const JOB_TYPE_STANDARD_EQUIPMENT = 'Standard Equipment';

export const JOB_TYPES = [
    { id: JOB_TYPE_NORMAL, text: JOB_TYPE_NORMAL },
    { id: JOB_TYPE_PROGRESSIVE, text: JOB_TYPE_PROGRESSIVE },
    { id: JOB_TYPE_SERVICE, text: JOB_TYPE_SERVICE },
    { id: JOB_TYPE_STANDARD_EQUIPMENT, text: JOB_TYPE_STANDARD_EQUIPMENT },
];

export const JOB_TYPES_WITHOUT_STANDARD_EQUIPMENT = [
    { id: JOB_TYPE_NORMAL, text: JOB_TYPE_NORMAL },
    { id: JOB_TYPE_PROGRESSIVE, text: JOB_TYPE_PROGRESSIVE },
    { id: JOB_TYPE_SERVICE, text: JOB_TYPE_SERVICE },
];

export const JOB_STATUS_OPEN = 'Open';
export const JOB_STATUS_PENDING = 'Pending';
export const JOB_STATUS_COMPLETE = 'Complete';
export const JOB_STATUS_NEW = 'New';
export const JOB_STATUS_IN_PROGRESS = 'In Progress';
export const JOB_STATUS_QA = 'QA';
export const JOB_STATUS_SHIPPING = 'Shipping';
export const JOB_STATUS_FULFILLED = 'Fulfilled';
export const JOB_STATUS_CLOSED = 'Closed';

export const JOB_STATUSES = [
    { id: JOB_STATUS_OPEN, text: JOB_STATUS_OPEN },
    { id: JOB_STATUS_PENDING, text: JOB_STATUS_PENDING },
    { id: JOB_STATUS_NEW, text: JOB_STATUS_NEW },
    { id: JOB_STATUS_IN_PROGRESS, text: JOB_STATUS_IN_PROGRESS },
    { id: JOB_STATUS_QA, text: JOB_STATUS_QA },
    { id: JOB_STATUS_SHIPPING, text: JOB_STATUS_SHIPPING },
    { id: JOB_STATUS_FULFILLED, text: JOB_STATUS_FULFILLED },
    { id: JOB_STATUS_CLOSED, text: JOB_STATUS_CLOSED },
];

export default class Job extends Model {
    static className = 'Job';

    resource() {
        return 'jobs';
    }

    get formFieldCasts() {
        return {
            equipment_amount: CurrencyFormatter.formFormat,
            labor_amount: CurrencyFormatter.formFormat,
            recap_invoice_amount: CurrencyFormatter.formFormat,
            recap_margin_amount: CurrencyFormatter.formFormat,
            recap_commission_amount: CurrencyFormatter.formFormat,
        };
    }

    relations() {
        return {
            customer: Customer,
            customer_location: CustomerLocation,
        };
    }

    proposals() {
        return this.hasMany(Proposal);
    }

    isProgressive() {
        return this.type === JOB_TYPE_PROGRESSIVE;
    }

    isService() {
        return this.type === JOB_TYPE_SERVICE;
    }

    isStandardEquipment() {
        return this.type === JOB_TYPE_STANDARD_EQUIPMENT;
    }
}
